import React, { useContext, useEffect, useState } from "react";
import * as FaIcons from "react-icons/fa";
import R1SummerSession from "./RegistrationFormSteps/R1SummerSession.js";
import R2StudentInformation from "./RegistrationFormSteps/R2StudentInformation.js";
import R3ParentInformation from "./RegistrationFormSteps/R3ParentInformation.js";
import R4PhysicalAddress from "./RegistrationFormSteps/R4PhysicalAddress.js";
import R5MailingAddress from "./RegistrationFormSteps/R5MailingAddress.js";
import R6Ethnicity from "./RegistrationFormSteps/R6Ethnicity.js";
import R7PreviousSchoolInformation from "./RegistrationFormSteps/R7PreviousSchoolInformation.js";
import R8PrimaryLanguage from "./RegistrationFormSteps/R8PrimaryLanguage.js";
import R9HomeLanguage from "./RegistrationFormSteps/R9HomeLanguage.js";
import R10MigrantEducation from "./RegistrationFormSteps/R10MigrantEducation.js";
import R11ReleaseRequests from "./RegistrationFormSteps/R11ReleaseRequests.js";
import R12DassInformation from "./RegistrationFormSteps/R12DassInformation.js";
import R13HomeSurvey from "./RegistrationFormSteps/R13HomeSurvey.js";
import R14HealthConditions from "./RegistrationFormSteps/R14HealthConditions.js";
import R15ParentCustodyInformation from "./RegistrationFormSteps/R15ParentCustodyInformation.js";
import R16EmergencyContacts from "./RegistrationFormSteps/R16EmergencyContacts.js";
import R17PreviewSubmission from "./RegistrationFormSteps/R17PreviewSubmission.js";
import R18CompletionScreen from "./RegistrationFormSteps/R18CompletionScreen.js";
import R22StudentPreferences from "./RegistrationFormSteps/R22StudentPreferences.js";
import RegistrationContext from "../../context/registration/registrationContext";
import ProgressButtons from "./ProgressButtons";
import R33Parent2Information from "./RegistrationFormSteps/R33Parent2Information.js";
import findBrand from "../findBrand.js";
import { brandDomains, fetchBrands } from "../brand.js";
import ErrorLogger from "../ErrorLogger.js";
import AdminInterestContext from "../../context/adminInterest/adminInterestContext";

// Accept uuid as prop
const RegistrationForInterest = ({ uuid }) => {
  const registrationContext = useContext(RegistrationContext);
  const {
    formData,
    formLevel,
    levelUp,
    setPass,
    submitData,
    onFormDataChange,
    learningCenterName,
  } = registrationContext;
  const adminInterestContext = useContext(AdminInterestContext);
  const { getEntriebyuuid,entriebyuuid,updateEnrollmentStatus  } = adminInterestContext;

  const [submitted, setSubmitted] = useState(false);
  // Add state to store the retrieved data
  const [existingData, setExistingData] = useState(null);
  const [isLoadingData, setIsLoadingData] = useState(false);
   const [learningCenterId, setLearningCenterId] = useState("");
   const [isSubmitting, setIsSubmitting] = useState(false);
  
  const onSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
     setIsSubmitting(true);

    try {
      if (validateFormData()) {        
       // Include both UUID and learningCenterId in the form data when submitting
        submitData({ ...formData, _uuid: uuid });
        
        const urlParams = new URLSearchParams(window.location.search);
        const currentUuid = urlParams.get('uuid') || uuid;
        //Updating enrollstatus in enrolment collection i.e interest form status
        if (currentUuid) {
          try {
             updateEnrollmentStatus(currentUuid, 'Yes','Enrolled');
            console.log('Enrollment status updated successfully');
          } catch (statusError) {
            console.error('Error updating enrollment status:', statusError);
            // Don't throw here - registration was successful even if status update failed
            ErrorLogger.logError(`Failed to update enrollment status for UUID ${currentUuid}: ${statusError.message}`);
          }
        }
      } else {
        const validationError = "Validation failed";
        console.log(validationError);
        ErrorLogger.logError(validationError);
      }
    } catch (error) {
      console.error('Registration submission error:', error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const validateFormData = () => {
    const {
      emergencyContact1FirstName,
      emergencyContact1LastName,
      emergencyContact1Phone,
      emergencyContact1Relationship,
      authorizedForPickup1,
      emergencyContact2FirstName,
      emergencyContact2LastName,
      emergencyContact2Phone,
      emergencyContact2Relationship,
      authorizedForPickup2,
      custodyIssueExists,
      custodyIssueNotes,
      legalRestrictionsForAnyParent,
      legalRestrictionsNotes,
    } = formData;

    if (findBrand(brand_holston) || findBrand(brand_pbia)) {
      const isCustodyValid =
        custodyIssueExists.yes === true || custodyIssueExists.no === true;

      const isLegalValid =
        legalRestrictionsForAnyParent.yes === true ||
        legalRestrictionsForAnyParent.no === true;

      return isCustodyValid && isLegalValid;
    } else {
      return (
        emergencyContact1FirstName !== "" &&
        emergencyContact1LastName !== "" &&
        emergencyContact1Phone !== "" &&
        emergencyContact1Relationship !== "" &&
        authorizedForPickup1 !== "" &&
        emergencyContact2FirstName !== "" &&
        emergencyContact2LastName !== "" &&
        emergencyContact2Phone !== "" &&
        emergencyContact2Relationship !== "" &&
        authorizedForPickup2 !== ""
      );
    }
  };

  useEffect(() => {
    const loadBrands = async () => {
      await fetchBrands();
    };

    loadBrands();
  }, []);

  // Modified useEffect to handle UUID and fetch data
  useEffect(() => {    
    const urlParams = new URLSearchParams(window.location.search);
    const uuid = urlParams.get('uuid');
    //console.log("uuid",uuid)
    const fetchExistingData = async () => {
     
      if (uuid) {
        //console.log("Received UUID in RegistrationForm:", uuid);
        setIsLoadingData(true);        
        try {
          // Store UUID in form data
          onFormDataChange({ target: { name: 'uuid', value: uuid } });
          
          // Fetch existing data
        //  console.log("Calling getEntriebyuuid with UUID:", uuid);
          const response = await getEntriebyuuid(uuid);
          //console.log("Retrieved response:", response.data);
          
          // Check if response exists and has data
          if (response && response.data) {
            const data = response.data;
           // console.log("Extracted data:", data);
            setExistingData(data);
            
            // Optionally pre-populate form data with existing information
            const mappedData = {
              firstName: data.studentFirstName || '',
              lastName: data.studentLastName || '',
              birthDate: data.birthDate || '',
              age: data.age || '',
              studentPrimaryPhone: data.phone || '',
              studentEmail: data.primaryEmail || '',
              parentFirstName: data.parentFirstName || '',
              parentLastName: data.parentLastName || '',
              parentRelationship: data.parentRelationship || '',
              street1: data.street1 || '',
              street2: data.street2 || '',
              city: data.city || '',
              state: data.state || '',
              zip: data.zipCode || '',
              country: data.country || '',
              mailingStreet1: data.mailingStreet1 || '',
              mailingStreet2: data.mailingStreet2 || '',
              mailingCity: data.mailingCity || '',
              mailingState: data.mailingState || '',
              mailingZipCode: data.mailingZipCode || '',
              mailingCountry: data.mailingCountry || '',
              sameAddress: data.sameAddress || false,
              learningCenterName: data.learningCenterName || '',
              learningCenterId: data.learningCenterId || '',
              learningCenterAddress: data.learningCenterAddress || '',
              learningCenterCharter: data.learningCenterCharter || '',
              uuid: uuid
            };
            
            // Update form data with existing information
            Object.keys(mappedData).forEach(key => {
              if (mappedData[key]) {
                onFormDataChange({ target: { name: key, value: mappedData[key] } });
              }
            });
          } else if (response && !response.data) {
            // If response exists but no data property, the response itself might be the data
            console.log("Response doesn't have data property, using response directly:", response);
            setExistingData(response);
          } else {
            console.log("No response or data received");
            setExistingData(null);
          }
        } catch (error) {
          console.error("Error fetching existing data:", error);
          ErrorLogger.logError(`Error fetching data for UUID ${uuid}: ${error.message}`);
          setExistingData(null);
        } finally {
          setIsLoadingData(false);
        }
      }
    };

    fetchExistingData();
  }, [uuid]);

  const brand_holston = brandDomains.brand_holston?.name;
  const brand_pbia = brandDomains.brand_pbia?.name;

  // Show loading state while fetching data
  if (isLoadingData) {
    return (
      <div id="registration-form">
        <h2 className="text-center">Student Registration</h2>
        <p className="text-center">Loading existing information...</p>
      </div>
    );
  }

  if (findBrand(brand_holston) === true || findBrand(brand_pbia) === true) {
    return (
      <div id="registration-form">
        <h2 className="text-center"> Student Registration </h2>
        {existingData && (
          <div className="text-center mb-3"></div>
        )}
        <form onSubmit={onSubmit} className="form">
          <div className="form-container">
            {formLevel === 0 && <R2StudentInformation existingData={existingData} />}
            {formLevel === 1 && <R22StudentPreferences existingData={existingData} />}
            {formLevel === 2 && <R3ParentInformation existingData={existingData} />}
            {formLevel === 3 && <R33Parent2Information existingData={existingData} />}
            {formLevel === 4 && <R4PhysicalAddress existingData={existingData} />}
            {formLevel === 5 && <R5MailingAddress existingData={existingData} />}
            {formLevel === 6 && <R6Ethnicity existingData={existingData} />}
            {formLevel === 7 && <R7PreviousSchoolInformation existingData={existingData} />}
            {formLevel === 8 && <R8PrimaryLanguage existingData={existingData} />}
            {formLevel === 9 && <R11ReleaseRequests existingData={existingData} />}
            {formLevel === 11 && <R18CompletionScreen existingData={existingData} />}
            {formLevel === 10 && (
              <R15ParentCustodyInformation
                validateFormData={validateFormData}
                submitted={submitted}
                existingData={existingData}
              />
            )}
          </div>
          {formLevel === 10 && (
            <div>
              <div className="btn-container">
                <input
                  type="submit"
                  value="Submit"
                  className="btn btn-l4l-green"
                />
              </div>
            </div>
          )}
        </form>
      </div>
    );
  } else {
    return (
      <div id="registration-form">
        <h2 className="text-center"> Student Registration </h2>
        {existingData && (
          <div className="text-center mb-3">
          </div>
        )}
        <form onSubmit={onSubmit} className="form">
          <div className="form-container">
            {formLevel === 0 && <R2StudentInformation existingData={existingData} />}
            {formLevel === 1 && <R3ParentInformation existingData={existingData} />}
            {formLevel === 2 && <R4PhysicalAddress existingData={existingData} />}
            {formLevel === 3 && <R5MailingAddress existingData={existingData} />}
            {formLevel === 4 && <R6Ethnicity existingData={existingData} />}
            {formLevel === 5 && <R7PreviousSchoolInformation existingData={existingData} />}
            {formLevel === 6 && <R8PrimaryLanguage existingData={existingData} />}
            {formLevel === 7 && <R9HomeLanguage existingData={existingData} />}
            {formLevel === 8 && <R10MigrantEducation existingData={existingData} />}
            {formLevel === 9 && <R11ReleaseRequests existingData={existingData} />}
            {formLevel === 10 && <R12DassInformation existingData={existingData} />}
            {formLevel === 11 && <R13HomeSurvey existingData={existingData} />}
            {formLevel === 12 && <R14HealthConditions existingData={existingData} />}
            {formLevel === 13 && <R15ParentCustodyInformation existingData={existingData} />}
            {formLevel === 15 && <R18CompletionScreen existingData={existingData} />}
            {formLevel === 14 && (
              <R16EmergencyContacts
                validateFormData={validateFormData}
                submitted={submitted}
                existingData={existingData}
              />
            )}
          </div>
          {formLevel === 14 && (
            <div>
              <div className="btn-container">
                <input
                  type="submit"
                  value="Submit"
                  className="btn btn-l4l-green"
                />
              </div>
            </div>
          )}
        </form>
      </div>
    );
  }
};

export default RegistrationForInterest;